module.exports = __webpack_public_path__ + "static/media/right-arrow-icon.9fe64448.svg";